import { useQuery } from '@tanstack/react-query';
import { getTeamMembers } from 'common/services/teams.v2.service';

import { useMemo } from 'react';

const useTeamMembersQuery = ({ team, enabled = false }) => {
  const { data, isLoading, error } = useQuery({
    enabled: enabled && !!team?.id,
    retry: false,
    refetchOnWindowFocus: false,
    queryKey: ['teamMembers', team?.id],
    queryFn: async () => {
      return await getTeamMembers(team.id);
    }
  });

  const members = useMemo(
    () => (data?.success && data?.responseObject ? data.responseObject : []),
    [data]
  );

  return {
    members,
    isLoading,
    error
  };
};

export default useTeamMembersQuery;
